import { PureComponent } from "react";
import { componentStyles, linkStyles } from "./footer-category-component.scss";
import { normalizeUrl } from "/utils/url";
import { trackEvent } from "/services/bigbrain-service";
import { FOOTER_LINK_CLICK } from "/constants/bigbrain-event-types";
import { withGenericConfig } from "/contexts/generic-config-context";

class FooterNewCategoryComponent extends PureComponent {
  trackLinkClick(event) {
    const { target } = event;
    const href = normalizeUrl(target.href);
    trackEvent(FOOTER_LINK_CLICK, { kind: href });
  }

  isLinkToDocument(url) {
    let urlArray = url.split(".");
    return urlArray[urlArray.length - 1] === "pdf";
  }

  linksRenderer() {
    const { links, translate } = this.props;

    return Object.keys(links).map((linkTitle, index) => {
      return (
        <div className="link" key={index}>
          <a
            onClick={this.trackLinkClick}
            href={links[linkTitle]}
            target={this.isLinkToDocument(links[linkTitle]) ? "_blank" : "_self"}
          >
            {translate(linkTitle)}
          </a>

          <style jsx>{linkStyles}</style>
        </div>
      );
    });
  }

  render() {
    const { title, translate } = this.props;

    return (
      <div className="footer-category-component">
        <h3 className="title">{translate(title)}</h3>
        <div className="links">{this.linksRenderer()}</div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

export default withGenericConfig(FooterNewCategoryComponent);
